<template>
  <div
    v-if="categoryList && categoryList.list && categoryList.list.length"
    class="plp-top-search-title"
  >
    <div v-if="!isMobileProp" class="page-plp__top">
      <!-- :style="{ 'margin-top': hasBreadcrumb ? '12px' : '64px' }" -->
      <h1 v-if="conditionKeyword" class="page-search_title">“{{ conditionKeyword }}”的相关结果</h1>
      <slot v-else name="left-title">
        <h1 class="title">
          {{ pageTitle }}
        </h1>
      </slot>
      <div
        v-if="!hiddenFilter"
        :style="{ 'margin-left': conditionKeyword || pageTitle ? '20px' : '' }"
        class="sort-pc"
      >
        {{ totalCount }} 件商品
      </div>
    </div>
    <div v-else class="page-plp__top">
      <div class="top_1">
        <h1 class="title">
          {{ pageTitle }}
        </h1>
        <div class="sort">{{ totalCount }} 件商品</div>
      </div>
      <svg
        class="top-svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="sharePage()"
      >
        <g id="24-2px-share-1">
          <g id="Union">
            <path
              d="M3 4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4C11 4.55228 10.5523 5 10 5H5V19H19V14C19 13.4477 19.4477 13 20 13C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4Z"
              fill="#14141E"
            />
            <path
              d="M21 4C21 3.44772 20.5523 3 20 3H14.6667C14.1144 3 13.6667 3.44772 13.6667 4C13.6667 4.55228 14.1144 5 14.6667 5H17.5859L9.51518 13.0707C9.12466 13.4612 9.12466 14.0944 9.51518 14.4849C9.9057 14.8754 10.5389 14.8754 10.9294 14.4849L19 6.41431V9.33333C19 9.88562 19.4477 10.3333 20 10.3333C20.5523 10.3333 21 9.88562 21 9.33333V4Z"
              fill="#14141E"
            />
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { GtMessage } from '@speedshop/template';

export default {
  name: 'queryResultsTips',
  data() {
    return {};
  },
  computed: {
    categoryList() {
      const data = (this.filterData && this.filterData.find(i => i.code === 'CATEGORY')) || {};
      function findSecondLastChildrenWithChildren(tree) {
        const secondLastChildrenWithChildren = [];

        function traverse(node, depth) {
          if (!node.list || node.list.length === 0) {
            return;
          }
          const firstChild = node.list[0];

          if (firstChild.list && firstChild.list.length) {
            for (const child of node.list) {
              traverse(child, depth - 1);
            }
          } else {
            secondLastChildrenWithChildren.push(node);
          }

          // if (depth === 1) {
          //   secondLastChildrenWithChildren.push(node);
          //   return;
          // }

          // for (const child of node.list) {
          //   traverse(child, depth - 1);
          // }
        }

        for (const root of tree) {
          traverse(root, 2);
        }

        return secondLastChildrenWithChildren;
      }

      const { list = [], ...others } = data;

      const newList = list.map(item => {
        const children = item.children.map(i => {
          return {
            ...i,
            list: (i.list || i.children || []).map(e => {
              return {
                ...e,
                list: (e.list || e.children || []).map(c => {
                  return {
                    ...c,
                    list: c.list || c.children,
                    name: c?.name || c.categoryName
                  };
                }),
                name: e?.name || e.categoryName
              };
            }),
            name: i?.name || i.categoryName
          };
        });
        return {
          ...item,
          list: children,
          name: item?.name || item.categoryName
        };
      });
      const { categoryCode, categoryCodeList = [] } = this.params || {};
      const filterCategory = [categoryCode, ...categoryCodeList].filter(i => i);
      const secondLastChildrenWithChildren = findSecondLastChildrenWithChildren(newList);
      // 过滤categoryCode
      const filterNoMatchData = secondLastChildrenWithChildren;
      // const filterNoMatchData = !filterCategory.length
      //   ? secondLastChildrenWithChildren
      //   : secondLastChildrenWithChildren.filter(i => {
      //       const matchChildren = i.list.some(c => {
      //         const pathCodeList = c.categoryPath?.split('>') || [];
      //         return filterCategory.some(e => {
      //           return pathCodeList.includes(e);
      //         });
      //       });
      //       return matchChildren;
      //     });
      // 去重
      const myMap = new Map();
      filterNoMatchData.forEach(item => {
        const { name, list } = item;
        if (myMap.has(name)) {
          const data = myMap.get(name);
          list.forEach(i => {
            data.listMap.set(i?.name, i);
          });
          myMap.set(name, { ...data, list: newList });
        } else {
          const listMap = new Map();
          list.forEach(i => {
            listMap.set(i?.name, i);
          });
          myMap.set(name, { ...item, listMap });
        }
      });
      const newListMap = [...myMap.values()];
      const resultList = newListMap.map(i => {
        return {
          ...i,
          list: [...i.listMap.values()].map(item => {
            return {
              ...item,
              originalCode: item.categoryCode,
              categoryCode: item?.name,
              code: item?.name,
              attrCate: 'CATEGORY'
            };
          })
        };
      });
      return {
        ...others,
        list: resultList
      };
    }
  },
  watch: {},
  props: {
    totalCount: {},
    onFilter: {},
    filterData: {
      type: Array,
      default: () => []
    },
    resetFilterData: {},
    conditionKeyword: {},
    params: {},
    pageTitle: {
      type: String,
      default: () => {
        return '';
      }
    },
    hasBreadcrumb: {
      type: Boolean,
      default: false
    },
    isMobileProp: {
      type: Boolean,
      default: false
    },
    hiddenFilter: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  methods: {
    sharePage() {
      if (!navigator.share) {
        GtMessage({
          message: '当前浏览器不支持分享',
          type: 'warning'
        });
        return;
      }
      navigator
        .share({
          title: document.title,
          text: '快来看看' + document.title,
          url: window.location.href
        })
        .then(() => {
          console.log('Share completed successfuly');
        })
        .catch(error => {
          console.log(`share failed: ${error}`);
        });
    }
  }
};
</script>

<style lang="scss">
.plp-top-search-title {
  .page-plp__top {
    width: auto;
    min-width: auto;
    max-width: auto;
    line-height: 60px;

    .title {
      font-size: 16px;
    }
    .sort {
      flex-grow: 1;
      text-align: right;
      font-size: 12px;
      // justify-content: flex-end;
      padding-right: 16px;
      flex-shrink: 0;
    }
  }
  .page-plp__top {
    // padding-top: 12px;
    display: flex;
    // align-items: center;
    // justify-content: space-between;
    .title {
      color: var(--main-color-ua-dark-grey, #14141e);

      /* cn/pingfang/bold/36 */
      font-family: PingFang SC;
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 42px; /* 116.667% */
      text-transform: capitalize;
    }
    .sort {
      display: flex;
      // align-items: center;
      flex-shrink: 0;
      color: var(--secondary-color-ua-cool-grey-03, #8c8c96);

      font-family: Neue Plak;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      > span {
        margin: 0px 24px;
        padding-top: 10px;
      }
      .el-form-item.gt-form-item {
        //  padding-top: 0px;
        margin-bottom: 0px;
        // .el-form-item__label {
        //   top: -14px;
        // }
      }
    }
    .sort-pc {
      color: var(--secondary-color-ua-cool-grey-03, #8c8c96);
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 42px;
      text-transform: capitalize;
    }
  }
}
</style>
<style lang="scss">
.page-layout_mobile {
  .plp-top-search-title {
    .page-plp__top {
      display: flex;
      // height: 72px;
      padding: 24px 20px 0 20px;
      justify-content: flex-start;
      .top_1 {
        display: flex;
        flex: 1;
        flex-direction: column;
        margin-right: 24px;
        .title {
          // height: 26px;
          line-height: 26px;
          color: var(--main-color-ua-dark-grey, #14141e);
          font-family: PingFang SC;
          font-size: 20px;
          font-style: normal;
          font-weight: 600;
          text-transform: capitalize;
        }
        .sort {
          margin-top: 4px;
          height: 18px;

          text-align: left;
          line-height: 18px;
        }
      }
      .top-svg {
        top: 24px;
        position: absolute;
        right: 20px;
      }
    }
  }
}
</style>
